import { Component, OnInit, Inject, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { DOCUMENT, DatePipe } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { Job, OfferActivity} from '@app/shared';
import { Offer, OfferActionTypeDesc } from '../../models/offer';

//import { listTransition } from '@app/core';
import { Store } from '@ngrx/store';
import { AppState, selectOfferState, selectAuthState } from '@app/store/app.states';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { map, startWith, switchMap, debounceTime, distinctUntilChanged, withLatestFrom } from 'rxjs/operators';

import { GetOffers, OfferActionTypes, GetOffer, GetOfferHistory } from '@app/store/actions/offer.actions';
import { SortyByPipe } from '@app/shared';

@Component({
  selector: 'app-offer-history-dialog',
  templateUrl: './offer-history-dialog.component.html',
  styleUrls: ['./offer-history-dialog.component.scss'],
//animations: [ listTransition ]˛
})
export class OfferHistoryDialogComponent implements OnInit {

//  dialogFormGroup: FormGroup;
  jobs:Job[];
  offer:Offer;
  success:boolean = false;
  historyHash : Map<string, OfferActivity[]> = new Map<string, OfferActivity[]>();
  isLoading:boolean = false;
  currentActivityDate:string = '';
  currentActivityIdx:number = 0;

  private getOfferState$: Observable<any>;
  private offerStoreSubscription:Subscription;

  //@ViewChild('notifyForm') notifyForm;
  @ViewChild('perfectScrollbar') psb;
  @ViewChild('header') header:ElementRef;
  @ViewChildren('panelHeader') panels : QueryList < ElementRef >;

  constructor(
    public dialogRef: MatDialogRef<OfferHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: any,
    private fb: FormBuilder,
    private store:Store<AppState>,
    private datePipe: DatePipe,
  ) {

    this.jobs = data.jobs;
    this.offer = data.offer;

    // Offer State Subscription
    this.getOfferState$ = this.store.select(selectOfferState);
    this.offerStoreSubscription = this.getOfferState$.subscribe((state) => {
      console.log(state);
        if(state.actionType === OfferActionTypes.GET_OFFER_HISTORY_SUCCESS ){
          this.isLoading = false;
          this.groupOfferHistory();
        }
    //  this.offer = state.offer;
      //this.faveOffers = state.favourites;
      //this.isLoadingAssets = false;
    });

  }

  ngOnInit() {

    this.isLoading = true;
    // get the offer history.
    const payload = {offer:this.offer};
    this.store.dispatch(new GetOfferHistory(payload))
  }

  getValues(): Array<any> {
    let arr = [];
    this.historyHash.forEach((value: OfferActivity[], key: string) => {
        arr.push(key);
    });

    return arr;
  }

  groupOfferHistory():void{

    this.historyHash.clear();

    if(this.offer && this.offer.offerActivities && this.offer.offerActivities.length){
      this.currentActivityDate = this.datePipe.transform(this.offer.offerActivities[0].createdDate, 'mediumDate');
      for(let val of this.offer.offerActivities){
        let tmpDate = this.datePipe.transform(val.createdDate, 'mediumDate');

      //  let tmpDate = `${val.createdDate | date}`;
        if(this.historyHash.get(tmpDate)){
          
          let arr = this.historyHash.get(tmpDate);
            arr.push(val);
            this.historyHash = new Map(Array.from(this.historyHash).sort().reverse());
        }else{
            this.historyHash.set(tmpDate,[val]);
        }

      }
    }

    // this.historyHash = new Map(Array.from(this.historyHash).sort().reverse());

    console.log(this.historyHash, ' HISTORY')

  }

  getActionDescription(val:string):string{
    var str = OfferActionTypeDesc[val];

    if(!str)
      return;

    let arrText = str.split(' ');
    arrText[0] = `<i>${arrText[0]}</i>`;
    str = arrText.join(' ');
    return str;
  }

  getFormName(val:string):string{
    if(val == 'advsellvalue')
      val = 'asset sell price';

    if(val == 'productqty')
      val = 'product quantity';

    if(val == 'discounttype')
      val = 'discount type'
    
    if(val == 'advsavingsvalue')
      val = 'asset save price';
    val = val.replace(/([A-Z])/g, ' $1').trim().toLowerCase();
    return val;
  }
  getFormValue(val:string):string{
    if (val.includes('.')) {
      if (val.includes('00')) {
        val = val.replace('00','');
      }
    }
    return val;
  }
  
  getPanelHeader():string{
    let str = this.currentActivityDate;

    // if(this.selectedJob && this.selectedJob.campaignRegions){
    //   str += `${this.selectedJob.campaignRegions[0].name} `
    // }
    //
    // if(this.selectedJob && this.selectedJob.documentSegments)
    //   str += `- ${this.selectedJob.documentSegments.length} `;
    //
    // if(this.dataProvider.documentSegments && this.dataProvider.documentSegments.length)
    //   str += `${this.dataProvider.documentSegments[0].segmentIdentifier}s`
    //
    //
    // if(this.stuckHeader && this.currentDocumentSegment)
    //   str = `${this.currentDocumentSegment.segmentIdentifier} ${this.currentDocumentSegment.segmentNumber}`;

    return str;
  }

  getDateListClass(i):string{
    let cls = '';
    if(i > 5){
      let rem = i%5;
      cls = `date-${rem}`;
    }else{
      cls = `date-${i}`;
    }
    return cls;
  }
  onScrollY(event:any):void{

    const offset = this.header.nativeElement.offsetHeight;
    const scrollYTop = this.psb.elementRef.nativeElement.getBoundingClientRect().top;
    var minVal = 0;
    var idx = 0;
    var lastIdx = 0;
    //var segClass = `panel-header-${this.selectedJob.uuid}`;
    this.panels.forEach(elem=> {

      //if(elem.nativeElement.classList.contains(segClass)){
        let top = elem.nativeElement.getBoundingClientRect().top - scrollYTop -offset;
        minVal = top < minVal?top:minVal;
        if(top < 0)
          lastIdx = idx;
        ++idx;
      //}

    })

    // set the currentDocumentSegment
    console.log(lastIdx)
    var tmpCount = 0;
    let arr = [];
    this.historyHash.forEach((value: OfferActivity[], key: string) => {
      if(tmpCount === (lastIdx-1)){
        this.currentActivityDate = key;
        this.currentActivityIdx = tmpCount;
      }
      ++tmpCount;
    });

  }

  onSubmit(){

    this.success = true;
    // if(this.projectFormGroup.valid){
    //   this.project = this.prepareSaveProject();
    //
    //   const payload = {project:this.project};
    //   this.store.dispatch(new UpdateProject(payload));
    // }
  }

  close():void{

  }

  // destroy subscriptions
  ngOnDestroy():void{
      this.offerStoreSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/offer-history-dialog/offer-history-dialog.component.ts